module.exports = __webpack_public_path__ + "a0cd59f3f850ce4ae0ee6a32d237e759.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/wasistgoldencity2.jpg
// module id = 643
// module chunks = 0